var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wangEditor-container",on:{"contextmenu":_vm.preventContextMenu}},[_c('div',{ref:"wangEditor",staticClass:"wangEditor-txt",domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v("\n        "+_vm._s(_vm.content)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }